import { ProposalIntegrationHelloSign } from './proposalIntegrations.model';

export interface ProposalIntegrationsState {
  ids: string[];
  entities: Record<string, ProposalIntegrationHelloSign>;
  isLoading: boolean;
  isLoaded: boolean;
  error: string | null;
}

type Action =
  | { type: 'FETCH_PROPOSAL_INTEGRATIONS' }
  | {
      type: 'FETCH_PROPOSAL_INTEGRATIONS_SUCCESS';
      payload: { integrations: ProposalIntegrationHelloSign[] };
    }
  | {
      type: 'FETCH_PROPOSAL_INTEGRATIONS_FAILURE';
      payload: { error: string };
    }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: ProposalIntegrationsState = {
  ids: [],
  entities: {},
  isLoading: false,
  isLoaded: false,
  error: null,
};

export const proposalIntegrationsReducer = (
  state: ProposalIntegrationsState,
  action: Action
): ProposalIntegrationsState => {
  switch (action.type) {
    case 'FETCH_PROPOSAL_INTEGRATIONS':
      return {
        ...state,
        isLoading: true,
        isLoaded: !!state.ids.length,
        error: null,
      };
    case 'FETCH_PROPOSAL_INTEGRATIONS_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [
          ...new Set([
            ...state.ids,
            ...action.payload.integrations.map(
              (i) => i.organizationIntegrationId
            ),
          ]),
        ],
        entities: action.payload.integrations.reduce(
          (prev, curr) => ({
            ...prev,
            [curr.organizationIntegrationId]: curr,
          }),
          state.entities
        ),
      };
    case 'FETCH_PROPOSAL_INTEGRATIONS_FAILURE':
      return { ...state, isLoading: false, error: action.payload.error };
    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
